import React from 'react'
import StemTimeSelect from './StemTimeSelect'

function MilesSection({
	minMiles,
	maxMiles,
	handleInputChange,
	isConfirming,
	isDarkMode,
	load,
	// Pricing props
	adjustedPricePerMile,
	adjustedPrice,
	stemTime,
	lastEditedField,
	onPricePerMileChange,
	onPriceChange,
	onStemTimeChange,
}) {
	return (
		<div className="flex justify-between items-start mb-6 px-2">
			{/* Stops */}
			<div className="flex flex-col items-center min-w-0">
				<div className="h-6 flex items-center justify-center">
					<div
						className={`text-sm ${isDarkMode ? 'text-white' : 'text-gray-900'}`}
					>
						{load?.stopCount || 0}
					</div>
				</div>
				<div
					className={`text-xs font-medium tracking-wide mt-1 ${
						isDarkMode ? 'text-gray-400' : 'text-gray-400'
					}`}
				>
					Stops
				</div>
			</div>

			{/* Min Miles */}
			<div className="flex flex-col items-center min-w-0">
				<input
					type="number"
					min="1"
					value={minMiles}
					onChange={e => handleInputChange('minMiles', e.target.value)}
					className={`
						w-14 h-6 text-center text-[10px] font-medium border border-gray-300 rounded px-1
						focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
						${
							isDarkMode
								? 'text-white bg-gray-700 border-gray-600'
								: 'text-gray-900 bg-white'
						}
						${isConfirming ? 'opacity-50 cursor-not-allowed' : ''}
					`}
					disabled={isConfirming}
				/>
				<div
					className={`text-xs font-medium tracking-wide mt-1 ${
						isDarkMode ? 'text-gray-400' : 'text-gray-400'
					}`}
				>
					Min Miles
				</div>
			</div>

			{/* Max Miles */}
			<div className="flex flex-col items-center min-w-0">
				<input
					type="number"
					min="1"
					value={maxMiles}
					onChange={e => handleInputChange('maxMiles', e.target.value)}
					className={`
						w-14 h-6 text-center text-[10px] font-medium border border-gray-300 rounded px-1
						focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
						${
							isDarkMode
								? 'text-white bg-gray-700 border-gray-600'
								: 'text-gray-900 bg-white'
						}
						${isConfirming ? 'opacity-50 cursor-not-allowed' : ''}
					`}
					disabled={isConfirming}
				/>
				<div
					className={`text-xs font-medium tracking-wide mt-1 ${
						isDarkMode ? 'text-gray-400' : 'text-gray-400'
					}`}
				>
					Max Miles
				</div>
			</div>

			{/* Driver Type */}
			<div className="flex flex-col items-center min-w-0">
				<div className="h-6 flex items-center justify-center">
					<div
						className={`text-sm ${isDarkMode ? 'text-white' : 'text-gray-900'}`}
					>
						{load.driverType || 'Solo'}
					</div>
				</div>
				<div
					className={`text-xs font-medium tracking-wide mt-1 ${
						isDarkMode ? 'text-gray-400' : 'text-gray-400'
					}`}
				>
					Driver Type
				</div>
			</div>

			{/* Price Per Mile */}
			<div className="flex flex-col items-center min-w-0">
				<div className="flex items-center gap-1">
					<div className="relative">
						<span
							className={`absolute left-0.5 top-1/2 transform -translate-y-1/2 text-xs ${
								isDarkMode ? 'text-gray-400' : 'text-gray-600'
							}`}
						>
							$
						</span>
						<input
							type="number"
							step="0.01"
							min="0"
							max="100"
							value={adjustedPricePerMile}
							onChange={e => onPricePerMileChange(e.target.value)}
							onFocus={e => e.target.select()}
							className={`
								w-16 h-6 text-center text-[10px] font-medium border border-gray-300 rounded pl-3 pr-1
								focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
								${
									isDarkMode
										? 'text-white bg-gray-700 border-gray-600'
										: 'text-gray-900 bg-white'
								}
								${isConfirming ? 'opacity-50 cursor-not-allowed' : ''}
							`}
							disabled={isConfirming}
						/>
					</div>
					<span
						className={`text-xs ${
							isDarkMode ? 'text-gray-400' : 'text-gray-600'
						}`}
					>
						/mi
					</span>
				</div>
				<div
					className={`text-xs font-medium tracking-wide flex items-center justify-center gap-1 mt-1 ${
						isDarkMode ? 'text-gray-400' : 'text-gray-400'
					}`}
				>
					Per Mile
					{lastEditedField === 'pricePerMile' && (
						<span className="text-blue-500 text-[10px]">(edited)</span>
					)}
				</div>
			</div>

			{/* Payout */}
			<div className="flex flex-col items-center min-w-0">
				<div className="relative">
					<span
						className={`absolute left-0.5 top-1/2 transform -translate-y-1/2 text-xs ${
							isDarkMode ? 'text-gray-400' : 'text-gray-600'
						}`}
					>
						$
					</span>
					<input
						type="number"
						step="0.01"
						min="0"
						max="50000"
						value={adjustedPrice}
						onChange={e => onPriceChange(e.target.value)}
						onFocus={e => e.target.select()}
						className={`
							w-20 h-6 text-center text-[10px] font-medium border border-gray-300 rounded pl-3
							focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
							${
								isDarkMode
									? 'text-white bg-gray-700 border-gray-600'
									: 'text-gray-900 bg-white'
							}
							${isConfirming ? 'opacity-50 cursor-not-allowed' : ''}
						`}
						disabled={isConfirming}
					/>
				</div>
				<div
					className={`text-xs font-medium tracking-wide flex items-center justify-center gap-1 mt-1 ${
						isDarkMode ? 'text-gray-400' : 'text-gray-400'
					}`}
				>
					Payout
					{lastEditedField === 'price' && (
						<span className="text-blue-500 text-[10px]">(edited)</span>
					)}
				</div>
			</div>

			{/* Stem Time */}
			<div className="flex flex-col items-center min-w-0">
				<StemTimeSelect
					value={stemTime}
					onChange={onStemTimeChange}
					disabled={isConfirming}
					isDarkMode={isDarkMode}
				/>
			</div>
		</div>
	)
}

export default MilesSection
